module.exports = __webpack_public_path__ + "./static/img/algo.c208da31cd007c54f6c0b30cda7a052f.png";


//////////////////
// WEBPACK FOOTER
// ./client/src/assets/fontawesome/algo.png
// module id = ./client/src/assets/fontawesome/algo.png
// module chunks = 0